exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header--with-button[data-v-222a36c3]{display:flex;justify-content:space-between}", ""]);

// exports
